import React from 'react'
import {Button} from 'react-weui'
import {isLZWKAPP} from '../../../utils'
import Quan from '../../../images/activity/inviteNew/quan.png'
import Wp from '../../../images/activity/inviteNew/wx.png'

export default (clickHandle) => (
    <div className="invite-share">
        <p className="invite-share__title">分享知识 就这一课</p>
        <p className="invite-share__tips">分享当前页，给好友送课程，TA听你也听</p>
        {isLZWKAPP() ?
            <Button type="primary" className="invite-share__btn" onClick={() => clickHandle.shareClickHandle()}>点击分享给好友</Button>
            :
            <div className="invite-share__btns">
                <img src={Wp} className="invite-share__btn__item" onClick={() => clickHandle.shareClickHandle()}/>
                <img src={Quan} className="invite-share__btn__item" onClick={() => clickHandle.shareClickHandle()}/>
            </div>
        }
    </div>
)



// WEBPACK FOOTER //
// ./src/pages/AppPage/InviteNewUser/InviteShare.js